/**
 * @fileoverview gRPC-Web generated client stub for devices
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v3.20.3
// source: api/dashboard/v2/devices_service.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var api_dashboard_v2_department_message_pb = require('../../../api/dashboard/v2/department_message_pb.js')

var api_dashboard_v2_site_message_pb = require('../../../api/dashboard/v2/site_message_pb.js')
const proto = {};
proto.devices = require('./devices_service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.devices.DevicesClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.devices.DevicesPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.devices.DevicesRequest,
 *   !proto.devices.DevicesResponse>}
 */
const methodDescriptor_Devices_GetDevices = new grpc.web.MethodDescriptor(
  '/devices.Devices/GetDevices',
  grpc.web.MethodType.UNARY,
  proto.devices.DevicesRequest,
  proto.devices.DevicesResponse,
  /**
   * @param {!proto.devices.DevicesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.devices.DevicesResponse.deserializeBinary
);


/**
 * @param {!proto.devices.DevicesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.devices.DevicesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.devices.DevicesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.devices.DevicesClient.prototype.getDevices =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/devices.Devices/GetDevices',
      request,
      metadata || {},
      methodDescriptor_Devices_GetDevices,
      callback);
};


/**
 * @param {!proto.devices.DevicesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.devices.DevicesResponse>}
 *     Promise that resolves to the response
 */
proto.devices.DevicesPromiseClient.prototype.getDevices =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/devices.Devices/GetDevices',
      request,
      metadata || {},
      methodDescriptor_Devices_GetDevices);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.devices.DevicesSetDepartmentRequest,
 *   !proto.devices.DevicesResponse>}
 */
const methodDescriptor_Devices_SetDepartmentDevice = new grpc.web.MethodDescriptor(
  '/devices.Devices/SetDepartmentDevice',
  grpc.web.MethodType.UNARY,
  proto.devices.DevicesSetDepartmentRequest,
  proto.devices.DevicesResponse,
  /**
   * @param {!proto.devices.DevicesSetDepartmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.devices.DevicesResponse.deserializeBinary
);


/**
 * @param {!proto.devices.DevicesSetDepartmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.devices.DevicesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.devices.DevicesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.devices.DevicesClient.prototype.setDepartmentDevice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/devices.Devices/SetDepartmentDevice',
      request,
      metadata || {},
      methodDescriptor_Devices_SetDepartmentDevice,
      callback);
};


/**
 * @param {!proto.devices.DevicesSetDepartmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.devices.DevicesResponse>}
 *     Promise that resolves to the response
 */
proto.devices.DevicesPromiseClient.prototype.setDepartmentDevice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/devices.Devices/SetDepartmentDevice',
      request,
      metadata || {},
      methodDescriptor_Devices_SetDepartmentDevice);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.devices.DevicesSetSiteRequest,
 *   !proto.devices.DevicesResponse>}
 */
const methodDescriptor_Devices_SetSiteDevice = new grpc.web.MethodDescriptor(
  '/devices.Devices/SetSiteDevice',
  grpc.web.MethodType.UNARY,
  proto.devices.DevicesSetSiteRequest,
  proto.devices.DevicesResponse,
  /**
   * @param {!proto.devices.DevicesSetSiteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.devices.DevicesResponse.deserializeBinary
);


/**
 * @param {!proto.devices.DevicesSetSiteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.devices.DevicesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.devices.DevicesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.devices.DevicesClient.prototype.setSiteDevice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/devices.Devices/SetSiteDevice',
      request,
      metadata || {},
      methodDescriptor_Devices_SetSiteDevice,
      callback);
};


/**
 * @param {!proto.devices.DevicesSetSiteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.devices.DevicesResponse>}
 *     Promise that resolves to the response
 */
proto.devices.DevicesPromiseClient.prototype.setSiteDevice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/devices.Devices/SetSiteDevice',
      request,
      metadata || {},
      methodDescriptor_Devices_SetSiteDevice);
};


module.exports = proto.devices;

